import type { PatientInsightsGranularity } from '../../../../services/practicePatientInsights';
import { GranularityToggle, type GranularityOption } from '../../GranularityToggle';

const OPTIONS: GranularityOption<PatientInsightsGranularity>[] = [
    { key: 'week', label: 'Week' },
    { key: 'month', label: 'Month' },
    { key: 'year', label: 'Year' }
];

interface PatientInsightsGranularityToggleProps {
    value: PatientInsightsGranularity;
    onChange: (next: PatientInsightsGranularity) => void;
}

// Drives each PatientInsightsCard's own granularity state independently -
// Submissions and Approvals can be viewed at different granularities.
export function PatientInsightsGranularityToggle({
    value,
    onChange
}: PatientInsightsGranularityToggleProps) {
    return (
        <GranularityToggle
            value={value}
            onChange={onChange}
            options={OPTIONS}
            ariaLabel="Patient insights granularity"
        />
    );
}
